var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",style:([_vm.bgUrl ? { 'background-image': 'url(' + _vm.bgUrl + ')' } : {}])},[_c('Menu'),_c('div',{staticClass:"center"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }